/* eslint-disable no-undef */
import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { Charts } from './charts';
import { Page } from '../Page';
import { Downloads } from './downloads';
import "datatables.net";
import { Common } from '../all/common';

export class IntranetPage extends Page {
    public static render(params: RouteParams): void {
        setTimeout(() => {
            IntranetPage._MenuLanguage();
            IntranetPage._DataTable();
            Common.openActionsBehaviour();
            IntranetPage._Menu();
            IntranetPage._CreateNewOrderButton();

            const charts = new Charts();
            const downloads = new Downloads();
        }, 250);
    }

    private static _Menu(): void {
        $('body').on('click', function () {
            $('.menu-item--expanded').removeClass('open');
        });

        $('.menu-item--expanded .nav-link').on('click', function (e) {
            e.stopPropagation();
            const menu_item = $(this).closest('.menu-item--expanded');
            menu_item.toggleClass('open');
        });

        $('.menu-item--expanded').on('click', function (e) {
            e.stopPropagation();
        });

        $('.menu-lateral-toggle').on('click', function (e) {
            e.stopPropagation();
            $('body').toggleClass('menu-open');
        });

    }

    private static _MenuLanguage(): void {
        $('body').on('click', function () {
            $('#block-languageswitchercontent .nav > ul > li > ul').removeClass('open');
        });

        $('body').on('click', '#block-languageswitchercontent .nav > ul > li > span', function (e) {
            e.stopPropagation();

            const menu = $(this).closest('li').find('> ul');
            menu.toggleClass('open');
        });

        $('body').on('click', '#block-languageswitchercontent .nav > ul > li > ul', function (e) {
            e.stopPropagation();
        });
    }

    private static _DataTable() {
        const data_table = $('table.data-table');

        if (data_table.find('thead').length > 0) {
            data_table.dataTable({
                "responsive": true,
                "paging": false,
                "searching": false,
                "info": false,
                "ordering": true,
                "order": [[0, "asc"]],
            })
        }
    }

    private static _CreateNewOrderButton() {
        const button = $('.menu-lateral .nuevo-pedido');
        const body = $('body');

        if (button.length == 0) return;

        const button_clone = button.clone();

        button_clone.addClass('btn btn-fixed btn-nuevo-pedido-fixed hide-not-comercial');
        button_clone.removeClass('active');

        const text = $('<span></span>').addClass('texto').html(button_clone.html());
        const icon = $('<span></span>').addClass('material-icons').html('add_shopping_cart');

        button_clone.html('');
        button_clone.append(text);
        button_clone.append(icon);
        body.append(button_clone);
    }
}
